import { validateQueryParams } from '../../utils/api/api-utils';
import {
  doGetQCXRequest,
  doPostQCXRequest,
  doPutQCXActivateRequest,
  doPutQCXInactivateRequest,
  doPutQCXRequest,
} from '../../utils/api/domain/domain-api-utils';
import { FILTER_ENDPOINT, ETAPA_ENDPOINT, ETAPA_DTO_ENDPOINT } from '../../utils/api/domain/domain-endpoint-utils';

export async function fetchAll() {
  return doGetQCXRequest([
    ETAPA_ENDPOINT
  ]);
}
export async function fetchByFilter(params = []) {
  const validatedParams = validateQueryParams(params);
  if (validatedParams.length) {
    return doGetQCXRequest([
      ETAPA_ENDPOINT, FILTER_ENDPOINT
    ], validatedParams);
  }
  return { data: [] };
}

export async function fetchById(id) {
  return doGetQCXRequest([
    ETAPA_ENDPOINT,
    id
  ]);
}

export async function register(data) {
  return doPostQCXRequest(
    [ETAPA_ENDPOINT],
    data
  );
}

export async function save(data) {
  return doPutQCXRequest(
    [ETAPA_ENDPOINT],
    data
  );
}

export async function saveEtapas(data) {
  return doPutQCXRequest([ETAPA_DTO_ENDPOINT], data);
}

export async function activateById(id) {
  return doPutQCXActivateRequest(
    [ETAPA_ENDPOINT],
    id
  );
}

export async function inactivateById(id) {
  return doPutQCXInactivateRequest(
    [ETAPA_ENDPOINT],
    id
  );
}
